exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.layers-list .dropdown > .btn {\n  background: transparent;\n  border: none;\n  color: #007bff;\n  padding: 3px !important;\n  box-shadow: none;\n}\n.layers-container {\n  position: relative !important;\n}\n.layers-list-group-item {\n  border: none !important;\n  padding: 0.5em !important;\n}\n.layers-list-group-item:hover {\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n.version-info {\n  line-height: 40px;\n  margin: auto;\n}\n.layers-loading {\n  position: sticky;\n  position: -webkit-sticky;\n  bottom: 0;\n  left: 50%;\n}\n", ""]);

// exports
